export default {
  path: "/SectionContent/CommercialMotorVehicles",
  name: "Commercial Motor Vehicles",
  htmlContent: "commercial_motor_vehicles.html",
  headings: [
    { id: "n71CarrierName", text: "71. Carrier Name", type: "field" },
    { id: "n72Address", text: "72. Address", type: "field" },
    { id: "n73USDOT", text: "73. US DOT #", type: "field" },
    { id: "n74OfAxles", text: "74. # of Axles", type: "field" },
    {
      id: "n75GrossVehicleWeightRatingGVWR",
      text: "75. Gross Vehicle Weight Rating (GVWR)",
      type: "field",
    },
    { id: "n76CargoBodyType", text: "76. Cargo Body Type", type: "field" },
    { id: "n77VehicleConfiguration", text: "77. Vehicle Configuration", type: "field" },
    { id: "n78InterstateOrIntrastate", text: "78. Interstate or Intrastate", type: "field" },
    { id: "n79FedReportable", text: "79. Fed Reportable", type: "field" },
    { id: "n80CDL", text: "80. CDL", type: "field" },
    { id: "n81CDLSuspended", text: "81. CDL Suspended?", type: "field" },
    { id: "n82VehiclePlacarded", text: "82. Vehicle Placarded", type: "field" },
    { id: "n83HazardousMaterials", text: "83. Hazardous Materials", type: "field" },
    { id: "n84HazMatReleased", text: "84. HazMat Released?", type: "field" },
    {
      id: "n85NameOrFourDigitNumberFromDiamondOrBox",
      text: "85. Name or Four Digit Number from Diamond or Box",
      type: "field",
    },
    {
      id: "n86OneDigitNumberFromBottomOfDiamond",
      text: "86. One Digit Number from Bottom of Diamond",
      type: "field",
    },
    { id: "n87CMVSequenceOfEvents", text: "87. CMV Sequence of Events", type: "field" },
  ],
};
